import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class GetTextContentService extends BaseService {
  constructor() {
    super(constants.FETCH_TEXT_CONTENT, 'GetTextContentService');
  }

  handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);

    // API call to fetch text content
    return this.getClient('aiadminv2').post(constants.TEXT_CONTENT_URL, payload, {
      headers
    });
  }

  handleResponse(response) {
    const { data } = response;
    // Publish the response back to the component
    Framework.getEventManager().publish(constants.SET_TEXT_CONTENT, {
      textContent: data?.data?.textContent || '',
      success: data?.success || false
    });
  }

  handleError(error) {
    // Publish error state
    Framework.getEventManager().publish(constants.SET_TEXT_CONTENT, {
      textContent: '',
      success: false,
      error: error.message
    });
  }
}
